import { useMutation, useQueryClient } from "@tanstack/react-query";
import { applyClientCreditToInvoice } from "api/clientCreditApplication.api";
import {
  invalidatePaymentSide,
  invalidateDashboardSources,
} from "lib/cacheInvalidation";
import { QUERY_KEYS } from "config/queryKeys";

export const useApplyClientCredit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clientId, payload }) =>
      applyClientCreditToInvoice(clientId, payload),

    onSuccess: () => {
      invalidatePaymentSide(queryClient);
      invalidateDashboardSources(queryClient);

      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.clientCreditApplications.all,
      });
    },
  });
};
